module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-01-m-jp.30007177e2f46704d7c6677c5777a64a.png";